import { atom } from 'jotai';

export type CountryCodeAtom = string;

export const countryCodeAtom = atom<string | undefined>('FR');
